import { configureStore } from '@reduxjs/toolkit';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import rootReducer from "../reducer/index";
import { createStateSyncMiddleware } from 'redux-state-sync';

// Import the CLEAR_DATA action type here
import { CLEAR_DATA } from '../actions/types'; // Adjust the path to your action types file

const persistConfig = {
  key: 'root',
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const stateSyncConfig = {
  channel: 'channel001', // Specify a unique channel name
  broadcastChannelOption: { type: 'localstorage' }, // Use local storage for communication
  blacklist: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE],
};

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE],
      },
    }).concat(createStateSyncMiddleware(stateSyncConfig)),
});

// Detect when the browser window is being closed
window.addEventListener('unload', () => {
  // Dispatch the CLEAR_DATA action when the user closes the window
  store.dispatch({ type: CLEAR_DATA });
});

export const persistor = persistStore(store);
